import { FC, ReactNode } from "react";
import CustomButton from "../CustomButton/CustomButton";
import Typhography from "../Typhography/Typhography";
import { Icon } from "@phosphor-icons/react";
import style from "./EmptyContainer.module.scss";
import { ShowByRole } from "../ShowByRole";

export const EmptyContainer: FC<{
  onClick: () => void;
  title: string;
  Icon: Icon;
  description: string;
  buttonText?: string;
  addButton?: boolean;
}> = ({ onClick, title, description, Icon, buttonText, addButton = true }) => {
  return (
    <div className={style.emptyContainer}>
      <div className={style.focusIconContainer}>
        <Icon className={style.focusIcon} />
      </div>
      <div className="d-flex flex-column gap-1 mt-5">
        <Typhography size="bold-20">{title}</Typhography>
        <Typhography size="regular-14" className="mt-1">
          {description}
        </Typhography>
        <ShowByRole roles={["isAdmin", "isDirector"]}>
          {addButton && (
            <CustomButton
              iconPosition="left"
              onClick={onClick}
              color="secondary"
              icon="plus"
              className="mt-4"
            >
              {buttonText}
            </CustomButton>
          )}
        </ShowByRole>
      </div>
    </div>
  );
};
export default EmptyContainer;
